export default __webpack_public_path__ + "static/media/poppins-regular.47c7dad4.svg";